import React from 'react';
import {callback} from '../../../helpers.js';
import PopupRowSelector from '../../farm/field/PopupRowSelector.js';

const HourlyTask = (props) => {
	const onRowsChange = (selected) => {
		callback(props.onChange, [{
			'rows': selected
		}]);
	}

	return false;
	return <PopupRowSelector date={props.date} field={props.field} rows={props.data.rows} onSubmit={onRowsChange} />;
}



HourlyTask.getdataformat = () => {
	return {
		'rows': []
	}
};

export default HourlyTask;